"use client";
import { createContext, useContext } from "react";
const defaultTableRowDrawerContext = {
    isDrawer: false,
    drawerContent: void 0,
    setDrawerContent: ()=>{},
    isOpen: false,
    setIsOpen: ()=>{}
};
const TableRowDrawerContext = /*#__PURE__*/ createContext(defaultTableRowDrawerContext);
const useTableRowDrawerContext = ()=>useContext(TableRowDrawerContext);
export { TableRowDrawerContext, defaultTableRowDrawerContext, useTableRowDrawerContext };
